export const FAMILY_HISTORY_FIELDS = [
  { key: "cancer", label: "Cancer" },
  { key: "diabetes", label: "Diabetes" },
  { key: "autoimmuneDisease", label: "Autoimmune Disease" },
  { key: "stroke", label: "Stroke" },
  { key: "other", label: "Other" },
  { key: "heartDisease", label: "Heart Disease" },
];
